import {
    getNiceEncodeData,
    getNiceEncodeDataByJoin,
    getNiceEncodeDataByPw,
    getNiceEncodeDataByPhone,
} from "../apis/api_nice.js";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {

    async GET_NICE_ENCODE_DATA(){
        try {
            const response = await getNiceEncodeData();
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_NICE_ENCODE_DATA_BY_JOIN(){
        try {
            const response = await getNiceEncodeDataByJoin();
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_NICE_ENCODE_DATA_BY_PW(){
        try {
            const response = await getNiceEncodeDataByPw();
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_NICE_ENCODE_DATA_BY_PHONE(){
        try {
            const response = await getNiceEncodeDataByPhone();
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

};

export default {mutations, state, actions, getters};